<!-- @format -->
<button
	class="warranty-button hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-p-xs hmf-p-m-s background-base hmf-w-100"
	[ngClass]="{ disabled: variant().disabled }"
	(click)="buttonClick(variant().buttonAction)">
	<div class="hmf-display-flex hmf-align-items-center">
		<homefield-icon
			name="security-verified-user"
			width="24px"
			height="24px"
			[fill]="variant().iconColor"
			class="hmf-mr-xxs" />
		<div class="hmf-display-flex hmf-flex-column hmf-align-items-flex-start">
			<div
				class="hmf-body-m"
				[ngClass]="{
					'hmf-body-bold-m': variant().showPlanName,
					'hmf-body-bold-s hmf-body-bold-m-m': variant().subtext
				}">
				{{ variant().text }}
				@if (variant().showPlanName) {
					<span class="hmf-body-m">{{ selectedWarrantyDisplayText() }}</span>
				}
			</div>
			@if (variant().subtext) {
				<div class="hmf-body-s">{{ variant().subtext }}</div>
			}
		</div>
	</div>
	@if (!variant().disabled) {
		<homefield-icon
			name="chevron-right"
			width="24px"
			height="24px" />
	}
</button>

<pdp-component-warranty-selection-drawer></pdp-component-warranty-selection-drawer>
